import React from 'react';

const CHANNEL_URL = 'https://www.youtube.com/@quietbambooo';

const post = {
  slug: 'quiet-bamboo',
  title: 'Quiet Bamboo: Calm Stories for a Loud World',
  date: '2026-08-13',
  cover: 'https://i.ytimg.com/vi/I94oQh5PO1I/maxresdefault.jpg',
  coverAlt: 'A watercolour of a lone boat on a calm river beneath misty mountains',
  excerpt:
    'Introducing Quiet Bamboo, our YouTube channel of calming Taoist and Confucian stories, and the video that found 104,000 viewers in its first few weeks.',
  content: (
    <>
      <p>
        Alongside Coach Ginge, we have been quietly working on a second YouTube
        channel: <a href={CHANNEL_URL}>Quiet Bamboo</a>. It is a very different
        kind of project. No workouts, no cats. Just short, calming narrated
        stories drawn from Taoist and Confucian philosophy, made for anyone who
        could use ten minutes of peace.
      </p>
      {/* TODO: channel banner or artwork image
          <img src="/blog/quiet-bamboo/banner.png" alt="Quiet Bamboo channel art" /> */}

      <h2>What it is</h2>
      <p>
        Each Quiet Bamboo video tells one old story, told slowly. A farmer and
        his horse. An empty boat drifting into yours. A tree that survives
        because nobody can find a use for it. These parables have been helping
        people put their worries down for a couple of thousand years, and it
        turns out they work just as well against modern ones: burnout,
        productivity guilt, the feeling that you should always be doing more.
      </p>
      <p>
        The format is deliberately simple. A calm voice, gentle visuals, one
        idea per video. No hot takes, no lists of habits, no shouting. The kind
        of thing you can put on at the end of a long day and let wash over you.
      </p>

      <h2>The surprise</h2>
      <p>
        The channel has only been live for a few weeks, but one video has
        already found its people.{' '}
        <a href="https://youtu.be/d9zFQ8EkEzs">
          You Don&apos;t Have to Be Useful
        </a>{' '}
        has passed 104,000 views, which still feels faintly absurd for a tiny
        new channel. It is a Taoist story about a tree that was never cut down
        precisely because it was considered useless, and what that might mean
        for anyone who feels crushed by the pressure to always be productive.
      </p>
      <p>
        Clearly it struck a nerve. The comments are full of people saying they
        needed to hear it, which is exactly why we started the channel in the
        first place.
      </p>

      <div className="video-embed">
        <iframe
          src="https://www.youtube.com/embed/d9zFQ8EkEzs"
          title="You Don't Have to Be Useful | A Calming Taoist Story"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      {/* TODO: screenshot of the video passing 104k views, or the video thumbnail
          <img src="/blog/quiet-bamboo/104k-views.png" alt="You Don't Have to Be Useful passing 104,000 views" /> */}

      <h2>Try one</h2>
      <p>
        If you are new to these stories, a good second stop is{' '}
        <a href="https://youtu.be/549_VfQLbzs">this one</a>. Same deal: press
        play, breathe, let an old story do the work.
      </p>

      <div className="video-embed">
        <iframe
          src="https://www.youtube.com/embed/549_VfQLbzs"
          title="A calming story from Quiet Bamboo"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>

      <h2>Pull up a cushion</h2>
      <p>
        New stories are landing regularly, and we are still finding the
        channel&apos;s voice, so now is a good time to get in early.{' '}
        <a href={CHANNEL_URL}>Subscribe to Quiet Bamboo on YouTube</a>, put the
        kettle on, and give yourself ten quiet minutes. The world will still be
        loud when you get back, but you might mind it less.
      </p>
    </>
  ),
};

export default post;
